<template>
  <div class="notice">
    <NavBar v-if="sourceIsH5" :narBarTitle="$t('通知参会人')" />
    <van-tabs class="notice-nav" title-active-color="#009BFF" line-height="0">
      <van-tab>
        <template #title>
          <div class="confereeBox-top">
            <img src="@/assets/images/adduser.png" alt="" />
            <div class="text">{{ $t('添加内部参会人') }}</div>
          </div>
        </template>
        <div class="confereeBox-bottom">
          <div class="searchBox" @click="toSearch">
            <img src="@/assets/images/search_big.png" alt="" />
            <p>{{ $t('搜索') }}</p>
          </div>
          <InsiderBox
            v-for="value in displayDepartmentList"
            :key="value.departmentId"
            :insiderName="value.departmentName"
            @click="delDepartment"
            bColor="1"
            :id="value.departmentId"
          />
          <InsiderBox
            v-for="(value, idx) in displayStaffList"
            :key="value.id"
            :insiderName="value.name"
            @click="delInsiderList"
            :idx="idx"
            :id="value.id"
          />
        </div>
        <div>
          <div class="menu-box">
            <div @click="toIndex">{{ $t('组织成员') }}</div>
            <ul class="child-menu">
              <li
                v-for="(item, idx) in navList"
                :key="item.departmentId"
                :style="{
                  color: idx + 1 == navList.length ? '#333333' : '#009BFF',
                }"
                @click="toMenu(item, idx)"
              >
                <img src="@/assets/images/pull.png" alt="" />
                <p>{{ item.departmentName }}</p>
              </li>
            </ul>
          </div>
          <div class="addressList-all">
            <van-checkbox-group v-model="selAll" ref="selectedAll">
              <van-checkbox @click="toggleAll" name="all">{{
                $t('全选')
              }}</van-checkbox>
            </van-checkbox-group>
          </div>
        </div>
        <div class="addressList-card" :style="{ maxHeight: addressHeight }">
          <van-checkbox-group
            v-model="indexResult"
            ref="departments"
            v-show="showAddressList"
          >
            <van-cell-group>
              <van-cell
                v-for="item in currentInfo"
                clickable
                :key="item.departmentId"
              >
                <template #title>
                  <van-checkbox
                    :name="item.departmentId"
                    @click="changeIndexDepartmentId(item)"
                    :disabled="
                      item.children && item.children.length == 0 && !item.staffs
                    "
                  >
                    {{ item.departmentName }}
                    <span :style="{ color: '#999999' }">
                      ({{ item.selectNum > 0 ? item.selectNum + '/' : null
                      }}{{ item.totalStaffCount }}{{ $t('人)') }}</span
                    >
                  </van-checkbox>
                </template>
                <template #right-icon>
                  <div
                    @click="toChild(item)"
                    class="contact-card"
                    v-show="item.totalStaffCount != 0"
                  >
                    <div></div>
                    <img
                      :src="
                        item.selectNum > 0
                          ? require('@/assets/images/inferior_actived.png')
                          : require('@/assets/images/inferior.png')
                      "
                      alt=""
                    />
                    <span
                      :style="{
                        opacity: item.selectNum > 0 ? 0.5 : 1,
                        color: '#009BFF',
                      }"
                      >{{ $t('下级') }}</span
                    >
                  </div>
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
          <div v-show="!showAddressList">
            <van-checkbox-group v-model="result" ref="childDepartments">
              <van-cell-group>
                <van-cell
                  v-for="item in currentInfo.children"
                  clickable
                  :key="item.departmentId"
                >
                  <template #title>
                    <van-checkbox
                      :name="item.departmentId"
                      @click="changeDepartmentId(item)"
                      :disabled="
                        item.children &&
                        item.children.length == 0 &&
                        !item.staffs
                      "
                    >
                      {{ item.departmentName }}
                      <span :style="{ color: '#999999' }">
                        ({{ item.selectNum > 0 ? item.selectNum + '/' : null
                        }}{{ item.totalStaffCount }}{{ $t('人)') }}</span
                      >
                    </van-checkbox>
                  </template>
                  <template #right-icon>
                    <div
                      @click="toChild(item)"
                      class="contact-card"
                      v-show="item.totalStaffCount != 0"
                    >
                      <div></div>
                      <img
                        :src="
                          item.selectNum > 0
                            ? require('@/assets/images/inferior_actived.png')
                            : require('@/assets/images/inferior.png')
                        "
                        alt=""
                      />
                      <span
                        :style="{
                          opacity: item.selectNum > 0 ? 0.5 : 1,
                          color: '#009BFF',
                        }"
                        >{{ $t('下级') }}</span
                      >
                    </div>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
            <van-checkbox-group
              v-model="staffResult"
              ref="staffs"
              :style="{ marginTop: '12px' }"
            >
              <van-cell-group>
                <van-cell
                  v-for="item in currentInfo.staffs"
                  clickable
                  :key="item.staffId + ':' + item.departmentId"
                >
                  <template #title>
                    <van-checkbox
                      :name="item.staffId"
                      @click="changeStaff(item.staffId, item.exceed)"
                    >
                      <div class="staffs-card">
                        <img
                          :src="
                            item.faceUrl ||
                            require('@/assets/images/default_avatar.png')
                          "
                          alt=""
                        />
                        <div>
                          <div class="staffs-card-title">
                            <div class="staffs-card-name">
                              {{ item.staffName }}
                            </div>
                            <div v-if="item.leader" class="staffs-card-tag">
                              {{ $t('主管') }}
                            </div>
                          </div>
                          <div class="staffs-card-job">{{ item.jobPost }}</div>
                        </div>
                      </div>
                    </van-checkbox>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </div>
        </div>
        <div class="agreeBox" :style="{ position: 'fixed' }">
          <div class="select-info">
            {{ $t('已选：') }}{{ selectNum }}{{ $t('人，其中有')
            }}{{ selectdepartmentNum }}{{ $t('部门') }}
          </div>
          <van-button
            round
            block
            type="info"
            native-type="submit"
            class="agree-btn"
            @click="onConfirm"
            >{{ $t('确定') }}</van-button
          >
        </div>
      </van-tab>
      <van-tab>
        <template #title>
          <div class="confereeBox-top">
            <img src="@/assets/images/adduser.png" alt="" />
            <div class="text">{{ $t('添加外部参会人') }}</div>
          </div>
        </template>
        <div class="outsiderWrap">
          <div class="outsider-content">
            <div
              class="outsiderBox"
              v-for="(item, idx) in outsiderList"
              :key="item.email"
            >
              <div class="outsiderMsg">
                <div class="outsiderName">{{ item.name }}</div>
                <div class="outsiderEMail">{{ item.email }}</div>
                <div class="outsiderDel">
                  <img
                    src="@/assets/images/small-del.png"
                    alt=""
                    @click="delOutsiderList(idx)"
                  />
                </div>
              </div>
            </div>
          </div>
          <img
            src="@/assets/images/add-outsider.png"
            alt=""
            class="add-outsider"
            @click="showOutsider = true"
          />
        </div>
        <div class="agreeBox" :style="{ position: 'fixed' }">
          <div class="select-info">
            {{ $t('已选：') }}{{ selectNum }}{{ $t('人，其中有')
            }}{{ selectdepartmentNum }}{{ $t('部门') }}
          </div>
          <van-button
            round
            block
            type="info"
            native-type="submit"
            class="agree-btn"
            @click="onConfirm"
            >{{ $t('确定') }}</van-button
          >
        </div>
      </van-tab>
    </van-tabs>
    <van-dialog
      v-model="showOutsider"
      show-cancel-button
      confirmButtonColor="#009BFF"
      cancelButtonColor="#009BFF"
      @confirm="confirmOutsider"
      class="outsiderStyle"
      :cancelButtonText="$t('暂不')"
      :confirmButtonText="$t('确定')"
    >
      <template #title>
        <div class="outsider-title">{{ $t('添加外部参会人员') }}</div>
      </template>
      <van-form class="hasBorder">
        <van-field :label="$t('姓名')" name="username">
          <template #input>
            <input
              type="text"
              :placeholder="$t('请输入姓名')"
              v-model="outsiderName"
              class="outsider-input"
            />
          </template>
        </van-field>
        <van-field
          :label="$t('邮箱')"
          :rules="[{ required: true, validator: emailTest }]"
          name="eMail"
        >
          <template #input>
            <input
              type="text"
              :placeholder="$t('请输入邮箱')"
              v-model="outsiderEmail"
              class="outsider-input"
            />
          </template>
        </van-field>
      </van-form>
    </van-dialog>
    <van-popup v-model="showSearch" class="search-model">
      <div class="search-navBar">
        <div class="left-icon" @click="leaveSearch">
          <van-icon name="arrow-left" />
        </div>
        <div class="search-box">
          <van-field
            v-model="searchName"
            :placeholder="$t('请输入搜索关键字')"
            :left-icon="require('@/assets/images/search.png')"
            class="search-name"
            clearable
            @input="selectStaff"
          />
        </div>
      </div>
      <van-checkbox-group v-model="searchResult" class="search-list">
        <van-cell-group>
          <van-cell v-for="item in searchList" clickable :key="item.id">
            <template #title>
              <van-checkbox
                :name="item.id"
                @click="changeStaffBySearch(item.id)"
              >
                <div class="staffs-card">
                  <img
                    :src="
                      item.faceUrl ||
                      require('@/assets/images/default_avatar.png')
                    "
                    alt=""
                  />
                  <div>
                    <div class="staffs-card-name">{{ item.name }}</div>
                    <div class="staffs-card-job">{{ item.jobPost }}</div>
                  </div>
                </div>
              </van-checkbox>
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <!-- <div class="agreeBox" :style="{ position: 'absolute' }">
        <div class="select-info">已选：{{ selectNum }}人，其中有{{ selectdepartmentNum }}部门</div>
        <van-button
          round
          block
          type="info"
          native-type="submit"
          class="agree-btn"
          @click="onConfirm"
        >
          确定
        </van-button>
      </div> -->
    </van-popup>
  </div>
</template>
<script>
import {
  getUserList,
  getAppointment,
  informAppointment,
  getstaffByDepartment,
} from '@/services/api'
import NavBar from '@/components/navBar'
import InsiderBox from '@/components/insiderBox'
import { isMobileType } from '@/utils/isMobileType.js'
import Vue from 'vue'
import {
  Picker,
  Calendar,
  Popup,
  Button,
  Form,
  Field,
  Dialog,
  Toast,
  Tab,
  Tabs,
  Checkbox,
  CheckboxGroup,
  Cell,
  CellGroup,
} from 'vant'
Vue.use(Picker)
Vue.use(Calendar)
Vue.use(Popup)
Vue.use(Button)
Vue.use(Form)
Vue.use(Field)
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Cell)
Vue.use(CellGroup)
export default {
  name: 'Notice',
  components: {
    NavBar,
    InsiderBox,
  },
  data() {
    return {
      user: {},
      insiderList: [],
      insiderTmpList: [],
      showInsider: false,
      showSeachList: false,
      searchList: [],
      userList: [],
      outsiderList: [],
      searchName: '',
      outsiderName: '',
      outsiderEmail: '',
      showOutsider: false,
      appointmentId: '',
      displayStaffList: [],
      displayDepartmentList: [],
      navList: [],
      indexResult: [],
      result: [],
      staffResult: [],
      currentInfo: [],
      totalInfo: [],
      staffIdList: [],
      searchResult: [],
      showSearch: false,
      selAll: [],
      showAddressList: true,
      addressHeight: null,
      sourceIsH5: true,
      ifFinished: false,
    }
  },
  methods: {
    delStaffIdList(id) {
      let filterArr = []
      this.staffIdList.forEach((item) => {
        if (item.id == id) {
          if (item.departmentId.includes(',')) {
            if (this.currentInfo.length) {
              this.delIndexDepartmentId([id], null)
            } else {
              if (this.currentInfo.children.length > 0) {
                this.deleteExceed(
                  this.currentInfo.children,
                  this.currentInfo.children,
                  id
                )
              }
            }
          } else {
            this.currentInfo.forEach((info) => {
              info.departmentId == item.departmentId &&
                (info.selectNum = info.selectNum - 1)
            })
          }
        } else {
          filterArr.push(item)
        }
      })
      this.staffIdList = filterArr
      this.staffResult.length > 0 &&
        (this.staffResult = this.staffResult.filter((item) => item != id))
      if (this.currentInfo.length) {
        this.currentInfo.forEach((item) => {
          if (item.selectNum != item.totalStaffCount) {
            this.indexResult = this.indexResult.filter(
              (departmentId) => departmentId != item.departmentId
            )
          }
        })
      }
      // this.staffIdList = this.staffIdList.filter(item => item.id != id)
      // this.staffResult = this.staffResult.filter(item => item != id)
    },
    delInsiderList(id, idx) {
      this.delStaffIdList(id)
      this.displayStaffList.splice(idx, 1)
      if (this.currentInfo == this.totalInfo) {
        this.currentInfo.forEach((item) => {
          item.selectNum = this.checkIfChildDepartmentSelected(item, true)
        })
      } else {
        let starffIds = this.currentInfo.staffs.map((item) => item.staffId)
        !starffIds.includes(id) &&
          this.currentInfo.children.forEach((item) => {
            item.selectNum = this.checkIfChildDepartmentSelected(item)
          })
        this.checkIfAllSelected()
      }
    },
    delDepartment(id) {
      this.AllDelete(this.totalInfo, id)

      if (this.currentInfo == this.totalInfo) {
        this.indexResult = this.indexResult.filter((item) => item != id)
        this.$refs.selectedAll && this.$refs.selectedAll.toggleAll(false)
        this.currentInfo.forEach((item) => {
          item.departmentId == id && (item.selectNum = 0)
        })
      } else {
        this.currentInfo.children.length > 0 &&
          this.currentInfo.children.forEach((item) => {
            item.departmentId == id && (item.selectNum = 0)
          })
        // this.result = this.indexResult.filter(item => item != id)
        this.checkIfAllSelected()
      }
    },
    AllDelete(data, id) {
      data.forEach((item) => {
        // if (this.currentInfo.departmentId == item.departmentId) {
        //   this.currentInfo.children.forEach(currentItem => {
        //     currentItem.selectNum = 0
        //   })
        // }
        if (id) {
          if (item.departmentId == id) {
            if (item.staffs && item.staffs.length > 0) {
              item.staffs.forEach((staffItem) =>
                this.delStaffIdList(staffItem.staffId)
              )
            }
            if (item.children.length > 0) {
              this.AllDelete(item.children)
            } else return
          } else {
            if (item.children.length > 0) {
              this.AllDelete(item.children, id)
            } else return
          }
        } else {
          if (item.staffs && item.staffs.length > 0) {
            item.staffs.forEach((staffItem) =>
              this.delStaffIdList(staffItem.staffId)
            )
          }
          if (item.children.length > 0) {
            this.AllDelete(item.children)
          } else return
        }
      })
    },
    delOutsiderList(idx) {
      this.outsiderList.splice(idx, 1)
    },
    async getUsers(companyId, appointmentId) {
      try {
        const res = await getUserList({ companyId })
        this.userList = res
        this.getInsiderId(appointmentId)
        this.ifFinished = true
      } catch (error) {
        console.log(error)
      }
    },
    confirmOutsider() {
      if (!this.emailTest()) {
        Toast.fail(this.$t('邮箱输入错误'))
        return
      }
      this.outsiderList.unshift({
        name: this.outsiderName,
        email: this.outsiderEmail,
      })
      this.outsiderName = ''
      this.outsiderEmail = ''
    },
    async getInsiderId(appointmentId) {
      try {
        const res = await getAppointment({ appointmentId })
        this.outsiderList = res.otherPeopleRecord
          ? JSON.parse(res.otherPeopleRecord)
          : []
        let nameList = [...res.attendDetails]
        nameList.forEach((item, idx) => {
          if (item.agree === false) {
            nameList.splice(idx, 1)
          }
        })
        let idList = nameList.map((item) => item.staffId)
        this.staffIdList = this.userList.filter((item) =>
          idList.includes(item.id)
        )
        this.getDepartment(this.user.companyId)
      } catch (error) {
        console.log(error)
      }
    },
    async onConfirm() {
      try {
        let meetingPeopleId = this.staffIdList.map((item) => item.id)
        let peopleId = []
        this.staffIdList.forEach((item) => {
          if (item.departmentId.includes(',')) {
            let departmentList = item.departmentId.split(',')
            departmentList.forEach((departmentId) =>
              peopleId.push(item.id + '-' + departmentId)
            )
          } else {
            peopleId.push(item.id + '-' + item.departmentId)
          }
        })
        await informAppointment({
          id: this.appointmentId,
          meetingPeopleId: meetingPeopleId.join(),
          otherPeopleRecord: JSON.stringify(this.outsiderList),
          meetingRoomId: this.meetingRoomId,
          developerId: this.user.companyId,
          peopleId: peopleId.join(','),
        })
        Toast.success(this.$t('已通知参会人'))
        setTimeout(() => {
          this.$router.push('/bookMeetings')
        }, 500)
      } catch (error) {
        Toast.fail(error.response.data)
      }
    },
    emailTest() {
      return /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(
        this.outsiderEmail
      )
    },
    toIndex() {
      this.indexResult = []
      this.navList = []
      this.showAddressList = true
      this.currentInfo = this.totalInfo
      this.currentInfo.forEach((item) => {
        item.selectNum = this.checkIfChildDepartmentSelected(item, true)
      })
      this.currentInfo.length === this.indexResult.length
        ? this.$refs.selectedAll.toggleAll(true)
        : this.$refs.selectedAll.toggleAll(false)
    },
    toMenu(data, idx) {
      this.result = []
      this.staffResult = []
      this.currentInfo = data
      this.navList = this.navList.slice(0, idx + 1)
      if (
        data.staffs &&
        data.staffs.length > 0 &&
        this.staffIdList.length > 0
      ) {
        this.staffIdList.forEach((item) => {
          data.staffs.forEach((item1) => {
            item.id == item1.staffId && this.staffResult.push(item1.staffId)
          })
        })
      }
      data.children.length > 0 &&
        data.children.forEach((item) => {
          item.selectNum = this.checkIfChildDepartmentSelected(item)
        })
      this.checkIfAllSelected()
    },
    toSearch() {
      if (!this.ifFinished) return
      this.searchList = []
      this.searchResult = []
      if (this.staffIdList.length > 0) {
        this.staffIdList.forEach((item) => {
          this.searchResult.push(item.id)
        })
      }
      this.showSearch = true
    },
    selectStaff(v) {
      this.searchList = []
      let arr = this.userList.filter((item) => {
        if (!item.name) return
        return item.name.includes(v)
      })
      this.searchList = arr
    },
    changeStaffBySearch(id) {
      if (this.searchResult.includes(id)) {
        this.userList.forEach((item) => {
          item.id == id && this.staffIdList.push(item)
        })
      } else {
        this.staffIdList.forEach((item, idx) => {
          item.id == id && this.staffIdList.splice(idx, 1)
        })
      }
    },
    leaveSearch() {
      if (this.currentInfo == this.totalInfo) {
        this.currentInfo.forEach((item) => {
          item.selectNum = this.checkIfChildDepartmentSelected(item, true)
        })
        this.currentInfo.length == this.indexResult.length
          ? this.$refs.selectedAll.toggleAll(true)
          : this.$refs.selectedAll.toggleAll(false)
      } else {
        if (this.currentInfo.children.length > 0) {
          this.currentInfo.children.forEach((item) => {
            item.selectNum = this.checkIfChildDepartmentSelected(item)
          })
        }
        if (this.currentInfo.staffs && this.currentInfo.staffs.length > 0) {
          let selectedIdList = this.staffIdList.map((item) => item.id)
          this.staffResult = []
          this.currentInfo.staffs.forEach((item) => {
            selectedIdList.includes(item.staffId) &&
              this.staffResult.push(item.staffId)
          })
        }
        this.checkIfAllSelected()
      }
      this.searchName = ''
      this.showSearch = false
    },
    toggleAll() {
      if (this.selAll.length) {
        if (this.currentInfo == this.totalInfo) {
          this.staffIdList = this.userList
          this.currentInfo.forEach((item) => {
            item.selectNum = item.totalStaffCount
          })
        }
        if (this.currentInfo.children && this.currentInfo.children.length > 0) {
          this.currentInfo.children.forEach((data) => {
            data.staffs &&
              data.staffs.length > 0 &&
              this.userList.forEach((item) => {
                data.staffs.forEach((item1) => {
                  item.id == item1.staffId &&
                    !this.ifSelected(item.id) &&
                    this.staffIdList.push(item)
                })
                this.checkDepartmentChild(data, item)
              })
          })
        }
        if (this.currentInfo.staffs && this.currentInfo.staffs.length > 0) {
          let currentInfoIdList = []
          this.currentInfo.staffs.forEach((item) => {
            currentInfoIdList.push(item.staffId)
          })
          let selectedIdList = this.staffIdList.map((item) => item.id)
          currentInfoIdList.forEach((id) => {
            if (selectedIdList.includes(id)) {
              return
            } else {
              this.userList.forEach((item) => {
                item.id == id && this.staffIdList.push(item)
              })
            }
          })
        }

        this.currentInfo.children &&
          this.currentInfo.children.forEach((item) => {
            item.selectNum = item.totalStaffCount
          })
        this.$refs.departments && this.$refs.departments.toggleAll(true)
        this.$refs.childDepartments &&
          this.$refs.childDepartments.toggleAll(true)
        this.$refs.staffs && this.$refs.staffs.toggleAll(true)
      } else {
        if (this.currentInfo == this.totalInfo) {
          this.displayDepartmentList = []
          this.staffIdList = []
          this.currentInfo.forEach((item) => {
            item.selectNum = 0
          })
        }
        if (this.currentInfo.children && this.currentInfo.children.length > 0) {
          this.currentInfo.children.forEach((data) => {
            let arr = []
            data.staffs &&
              data.staffs.length > 0 &&
              data.staffs.forEach((item) => arr.push(item.staffId))
            arr = this.delDepartmentChild(data, arr)
            this.staffIdList = this.staffIdList.filter(
              (item) => !arr.includes(item.id)
            )
          })
        }

        if (this.currentInfo.staffs && this.currentInfo.staffs.length > 0) {
          let arr = []
          this.currentInfo.staffs.forEach((item) => {
            arr.push(item.staffId)
          })
          this.staffIdList = this.staffIdList.filter((item) => {
            return !arr.includes(item.id)
          })
        }
        this.currentInfo.children &&
          this.currentInfo.children.forEach((item) => {
            item.selectNum = 0
          })
        this.displayDepartmentList = this.displayDepartmentList.filter(
          (item) => item.departmentId != this.currentInfo.departmentId
        )
        this.$refs.departments && this.$refs.departments.toggleAll(false)
        this.$refs.childDepartments &&
          this.$refs.childDepartments.toggleAll(false)
        this.$refs.staffs && this.$refs.staffs.toggleAll(false)
      }
    },
    async getDepartment(companyId) {
      const res = await getstaffByDepartment({ companyId })
      this.totalInfo = res
      this.currentInfo = res
      this.init()
    },
    init() {
      this.currentInfo.forEach((item) => {
        item.selectNum = this.checkIfChildDepartmentSelected(item, true)
      })
      this.currentInfo.length == this.indexResult.length
        ? this.$refs.selectedAll.toggleAll(true)
        : this.$refs.selectedAll.toggleAll(false)
    },
    changeIndexDepartmentId(data) {
      let exceedList = []
      let ifexceed = false
      if (this.indexResult.includes(data.departmentId)) {
        data.selectNum = data.totalStaffCount
        let initLength = this.staffIdList.length
        this.userList.forEach((item) => {
          data.staffs &&
            data.staffs.length > 0 &&
            data.staffs.forEach((item1) => {
              item.id == item1.staffId &&
                !this.ifSelected(item.id) &&
                this.staffIdList.push(item)
            })
          this.checkDepartmentChild(data, item)
        })
        let addList = [...this.staffIdList]
        addList = addList.splice(initLength, this.staffIdList.length)
        addList.forEach((item) => {
          if (item.departmentId.includes(',')) {
            exceedList.push(item.id)
            ifexceed = true
          }
        })
        if (ifexceed) {
          this.addIndexDepartmentId(exceedList, data.departmentId)
        }
        this.currentInfo.length === this.indexResult.length &&
          this.$refs.selectedAll.toggleAll(true)
      } else {
        let arr = []
        data.selectNum = 0
        data.staffs &&
          data.staffs.length > 0 &&
          data.staffs.forEach((item) => arr.push(item.staffId))
        arr = this.delDepartmentChild(data, arr)
        arr = Array.from(new Set(arr))
        this.userList.forEach((item) => {
          if (arr.includes(item.id) && item.departmentId.includes(',')) {
            exceedList.push(item.id)
            ifexceed = true
          }
        })
        if (ifexceed) {
          this.delIndexDepartmentId(exceedList, data.departmentId)
        }
        this.staffIdList = this.staffIdList.filter(
          (item) => !arr.includes(item.id)
        )
        this.indexResult.length == 0 && (this.displayDepartmentList = [])
        this.currentInfo.length !== this.indexResult.length &&
          this.$refs.selectedAll.toggleAll(false)
      }
    },
    addIndexDepartmentId(exceedList, ignoreId) {
      this.currentInfo.forEach((item) => {
        if (item.departmentId != ignoreId) {
          let selectNum = this.handlerIndexDepartmentId(
            item,
            item.selectNum,
            exceedList,
            true
          )
          item.selectNum = selectNum
        }
      })
    },
    handlerIndexDepartmentId(data, selectNum, exceedList, ifAdd) {
      let fn = (data) => {
        if (data.staffs && data.staffs.length > 0) {
          data.staffs.forEach((staff) => {
            if (exceedList.includes(staff.staffId)) {
              ifAdd ? (selectNum = selectNum + 1) : (selectNum = selectNum - 1)
            }
          })
        }
        if (data.children.length > 0) {
          data.children.forEach((childItem) => {
            fn(childItem)
          })
        }
      }
      fn(data, selectNum)
      return selectNum
    },
    delIndexDepartmentId(exceedList, ignoreId) {
      this.currentInfo.forEach((item) => {
        if (item.departmentId != ignoreId) {
          let selectNum = this.handlerIndexDepartmentId(
            item,
            item.selectNum,
            exceedList,
            false
          )
          item.selectNum = selectNum
        }
      })
    },
    checkDepartmentChild(data, item) {
      if (data.children.length > 0) {
        data.children.forEach((childItem) => {
          childItem.staffs &&
            childItem.staffs.length > 0 &&
            childItem.staffs.forEach((childStaffs) => {
              item.id == childStaffs.staffId &&
                !this.ifSelected(item.id) &&
                this.staffIdList.push(item)
            })
          this.checkDepartmentChild(childItem, item)
        })
      } else return
    },
    delDepartmentChild(data, arr) {
      if (data.children.length > 0) {
        data.children.forEach((childItem) => {
          childItem.staffs &&
            childItem.staffs.length > 0 &&
            childItem.staffs.forEach((item) => arr.push(item.staffId))
          arr = this.delDepartmentChild(childItem, arr)
        })
        return arr
      } else return arr
    },
    toChild(data) {
      this.result = []
      this.staffResult = []
      this.navList.push(data)
      this.showAddressList = false
      this.currentInfo = data
      if (data.staffs && data.staffs.length > 0) {
        data.staffs = [...data.staffs].sort(
          (a, b) => (b.leader ? 1 : 0) - (a.leader ? 1 : 0)
        )
      }
      if (
        data.staffs &&
        data.staffs.length > 0 &&
        this.staffIdList.length > 0
      ) {
        this.staffIdList.forEach((item) => {
          data.staffs.forEach((item1) => {
            item.id == item1.staffId && this.staffResult.push(item1.staffId)
          })
        })
      }
      data.children.length > 0 &&
        data.children.forEach((item) => {
          item.selectNum = this.checkIfChildDepartmentSelected(item)
        })
      this.checkIfAllSelected()
    },
    checkIfChildDepartmentSelected(data, ifIndex) {
      let checkNum = (departmentData) => {
        if (
          departmentData.children.length > 0 ||
          (departmentData.staffs && departmentData.staffs.length > 0)
        ) {
          let departmentNum = 0
          departmentData.children.length > 0 &&
            departmentData.children.forEach((item) => {
              if (
                item.children.length == 0 &&
                (!item.staffs || item.staffs.length == 0)
              )
                return 0
              let totalNum = checkNum(item)
              departmentNum += totalNum
            })
          let staffsNum = 0
          departmentData.staffs &&
            departmentData.staffs.length > 0 &&
            departmentData.staffs.forEach((item) => {
              this.staffIdList.forEach((item1) => {
                item1.id == item.staffId && staffsNum++
              })
            })
          return departmentNum + staffsNum
        } else return 0
      }
      let selectNum = checkNum(data)
      data.totalStaffCount != 0 &&
        data.totalStaffCount == selectNum &&
        (ifIndex
          ? !this.indexResult.includes(data.departmentId) &&
            this.indexResult.push(data.departmentId)
          : !this.result.includes(data.departmentId) &&
            this.result.push(data.departmentId))
      if (data.totalStaffCount !== selectNum) {
        if (ifIndex) {
          this.indexResult.includes(data.departmentId) &&
            (this.indexResult = this.indexResult.filter(
              (item) => item != data.departmentId
            ))
        } else {
          if (this.result.includes(data.departmentId)) {
            this.result = this.result.filter(
              (item) => item != data.departmentId
            )
          }
        }
      }
      return selectNum
    },
    checkIfAllSelected() {
      let currentNum =
        this.currentInfo.staffs && this.currentInfo.children
          ? this.currentInfo.children.length + this.currentInfo.staffs.length
          : this.currentInfo.children.length
      currentNum == this.result.length + this.staffResult.length
        ? this.$refs.selectedAll.toggleAll(true)
        : this.$refs.selectedAll.toggleAll(false)
    },
    changeDepartmentId(data) {
      let exceedList = []
      let ifexceed = false
      if (this.result.includes(data.departmentId)) {
        data.selectNum = data.totalStaffCount
        let initLength = this.staffIdList.length
        this.userList.forEach((item) => {
          data.staffs &&
            data.staffs.length > 0 &&
            data.staffs.forEach((item1) => {
              if (item.id == item1.staffId && !this.ifSelected(item.id)) {
                this.staffIdList.push(item)
              }
            })
          this.checkDepartmentChild(data, item)
        })
        let addList = [...this.staffIdList]
        addList = addList.splice(initLength, this.staffIdList.length)
        addList.forEach((item) => {
          if (item.departmentId.includes(',')) {
            exceedList.push(item)
            ifexceed = true
          }
        })
        if (ifexceed) {
          if (this.currentInfo.children.length > 1) {
            this.currentInfo.children.forEach((curDepartment) => {
              if (curDepartment.departmentId != data.departmentId) {
                exceedList.forEach((user) => {
                  this.checkDepartmentExceed(
                    curDepartment,
                    curDepartment,
                    user.id
                  )
                })
              }
            })
          }
          if (this.currentInfo.staffs && this.currentInfo.staffs.length > 0) {
            this.currentInfo.staffs.forEach((current) => {
              if (current.exceed) {
                if (!this.staffResult.includes(current.staffId)) {
                  exceedList.forEach((staff) => {
                    if (staff.id == current.staffId) {
                      this.staffResult.push(staff.id)
                    }
                  })
                }
              }
            })
          }
        }
      } else {
        let arr = []
        data.selectNum = 0
        data.staffs &&
          data.staffs.length > 0 &&
          data.staffs.forEach((item) => {
            arr.push(item.staffId)
            if (item.exceed) {
              exceedList.push(item)
              ifexceed = true
            }
          })
        arr = this.delDepartmentChild(data, arr)
        let filterList = []
        this.staffIdList.forEach((item) => {
          if (arr.includes(item.id)) {
            if (item.departmentId.includes(',')) {
              if (
                this.currentInfo.staffs &&
                this.currentInfo.staffs.length > 0
              ) {
                this.staffResult = this.staffResult.filter(
                  (staffId) => staffId != item.id
                )
              }
            }
          } else filterList.push(item)
        })
        if (ifexceed) {
          if (this.currentInfo.children.length > 0) {
            this.currentInfo.children.forEach((curDepartment) => {
              if (curDepartment.departmentId != data.departmentId) {
                exceedList.forEach((user) => {
                  this.deleteDepartmentExceed(
                    curDepartment,
                    curDepartment,
                    user.staffId
                  )
                })
              }
            })
          }
        }
        this.staffIdList = filterList
        this.result.length == 0 &&
          (this.displayDepartmentList = this.displayDepartmentList.filter(
            (item) => item.departmentId != data.departmentId
          ))
        // this.staffIdList = this.staffIdList.filter(item => !arr.includes(item.id))
      }
      this.checkIfAllSelected()
    },
    checkDepartmentExceed(data, currentData, id, ifFirst = true) {
      if (ifFirst && data.staffs && data.staffs.length > 0) {
        data.staffs.forEach((staffItem) => {
          if (staffItem.staffId == id) {
            data.selectNum = data.selectNum + 1
            if (data.selectNum == data.totalStaffCount) {
              !this.result.includes(data.departmentId) &&
                this.result.push(data.departmentId)
            }
          }
        })
      }
      currentData.children.length > 0 &&
        currentData.children.forEach((item) => {
          if (item.staffs && item.staffs.length > 0) {
            item.staffs.forEach((staffItem) => {
              if (staffItem.staffId == id) {
                data.selectNum = data.selectNum + 1
                if (data.selectNum == data.totalStaffCount) {
                  !this.result.includes(data.departmentId) &&
                    this.result.push(data.departmentId)
                }
              }
            })
          }
          if (item.children.length > 0) {
            this.checkDepartmentExceed(data, item, id, false)
          } else return
        })
    },
    deleteDepartmentExceed(data, currentData, id, ifFirst = true) {
      if (ifFirst && data.staffs && data.staffs.length > 0) {
        data.staffs.forEach((staffItem) => {
          if (staffItem.staffId == id) {
            data.selectNum = data.selectNum - 1
            this.result.length > 0 &&
              this.result.forEach((selectedId, idx) => {
                selectedId == data.departmentId && this.result.splice(idx, 1)
              })
          }
        })
      }
      currentData.children.length > 0 &&
        currentData.children.forEach((item) => {
          if (item.staffs && item.staffs.length > 0) {
            item.staffs.forEach((staffItem) => {
              if (staffItem.staffId == id) {
                data.selectNum = data.selectNum - 1
                this.result.length > 0 &&
                  this.result.forEach((selectedId, idx) => {
                    selectedId == data.departmentId &&
                      this.result.splice(idx, 1)
                  })
              }
            })
          }
          if (item.children.length > 0) {
            this.deleteDepartmentExceed(data, item, id, false)
          } else return
        })
    },
    changeStaff(id) {
      if (this.staffResult.includes(id)) {
        this.userList.forEach((item) => {
          item.id == id && this.staffIdList.push(item)
        })
        if (exceed) {
          if (this.currentInfo.children.length > 0) {
            this.addExceed(
              this.currentInfo.children,
              this.currentInfo.children,
              id
            )
            this.currentInfo.children.forEach((childItem) => {
              childItem.totalStaffCount == childItem.selectNum &&
                !this.result.includes(childItem.departmentId) &&
                this.result.push(childItem.departmentId)
            })
          }
        }
      } else {
        this.staffIdList.forEach((item, idx) => {
          item.id == id && this.staffIdList.splice(idx, 1)
        })
        //判断是否多部门
        if (exceed) {
          if (this.currentInfo.children.length > 0) {
            this.deleteExceed(
              this.currentInfo.children,
              this.currentInfo.children,
              id
            )
          }
        }
        if (this.currentInfo.children.length == 0) {
          this.displayDepartmentList = this.displayDepartmentList.filter(
            (item) => item.departmentId != this.currentInfo.departmentId
          )
        }
      }
      this.checkIfAllSelected()
    },
    addExceed(data, currentData, id, childNum, checkingId, checkNum) {
      currentData.forEach((item, index) => {
        if (item.staffs && item.staffs.length > 0) {
          item.staffs.forEach((staffItem) => {
            if (staffItem.staffId == id) {
              if (childNum != undefined && childNum != null) {
                data[childNum].selectNum = data[childNum].selectNum + 1
              } else {
                data[index].selectNum = data[index].selectNum + 1
              }
              if (checkNum) {
                !this.result.includes(checkingId) &&
                  this.result.push(checkingId)
              }
            }
          })
        }
        if (item.children.length > 0) {
          let nowDepartmentId = null
          if (!checkingId) {
            item.pid == this.currentInfo.departmentId &&
              (nowDepartmentId = item.departmentId)
          } else {
            nowDepartmentId = checkingId
          }
          let totalNum = true
          if (!checkNum) {
            item.totalStaffCount != 1 && (totalNum = false)
          }
          childNum ?? (childNum = index)
          this.addExceed(
            data,
            item.children,
            id,
            childNum,
            nowDepartmentId,
            totalNum
          )
        } else return
      })
    },
    deleteExceed(data, currentData, id, childNum, pid) {
      currentData.forEach((item, index) => {
        if (item.staffs && item.staffs.length > 0) {
          item.staffs.forEach((staffItem) => {
            if (staffItem.staffId == id) {
              if (childNum) {
                data[childNum].selectNum = data[childNum].selectNum - 1
              } else {
                data[index].selectNum = data[index].selectNum - 1
              }
              this.result.length > 0 &&
                this.result.forEach((selectedId, idx) => {
                  selectedId == item.departmentId && this.result.splice(idx, 1)
                  selectedId == item.pid && this.result.splice(idx, 1)
                  pid && selectedId == pid && this.result.splice(idx, 1)
                })
            }
          })
        }
        if (item.children.length > 0) {
          childNum ?? (childNum = index)
          this.deleteExceed(data, item.children, id, childNum, item.pid)
        } else return
      })
    },
    ifSelected(id) {
      return this.staffIdList.some((item) => item.id == id)
    },
    //上级部门查询
    checkSuperiorDepartment(data, departmentId, arr) {
      let response = null
      if (data.pid) {
        let pidDepartmentInfo = this.checkTotalStaffCount(
          this.totalInfo,
          data.pid
        )
        let slectedNum = this.staffIdList.filter(
          (item) => item.departmentId == pidDepartmentInfo.departmentId
        ).length
        if (
          slectedNum + data.totalStaffCount ==
          pidDepartmentInfo.totalStaffCount
        ) {
          let childData = pidDepartmentInfo.children.filter(
            (item) => item.departmentId == departmentId
          )[0]
          response = this.checkSuperiorDepartment(
            pidDepartmentInfo,
            pidDepartmentInfo.departmentId,
            arr,
            childData
          )
        } else {
          response = data
          return response
        }
      } else {
        response = data
        return response
      }
      return response
    },
    //下级部门查询
    checkSubordinateDepartment(data, selectedIdList) {
      let bl = true
      if (data.staffs && data.staffs.length > 0) {
        bl = data.staffs.every((childStaff) =>
          selectedIdList.includes(childStaff.staffId)
        )
      }
      if (bl && data.children.length > 0) {
        data.children.forEach((item) => {
          bl = this.checkSubordinateDepartment(item, selectedIdList)
        })
      }
      return bl
    },
    checkselectedDepartment(data, arr) {
      if (data.length > 0) {
        data.forEach((item) => {
          arr.push(item.departmentId)
          this.checkselectedDepartment(item.children, arr)
        })
      } else return
    },
    checkTotalStaffCount(data, id) {
      let selectedData = {}
      data.some((item) => {
        if (item.departmentId == id) {
          selectedData = item
          return true
        } else {
          if (item.children && item.children.length > 0) {
            // selectedData = this.checkTotalStaffCount(item.children, id)
            let returnData = this.checkTotalStaffCount(item.children, id)
            returnData.staffs && (selectedData = returnData)
          } else return
        }
      })
      return selectedData
    },
    fliterDepartment(data, arr) {
      data.forEach((item) => {
        item.staffs &&
          item.staffs.length > 0 &&
          item.staffs.forEach((staffItem) => arr.push(staffItem.staffId))
        item.children.length > 0 && this.fliterDepartment(item.children, arr)
      })
      return arr
    },
    isWeixin() {
      if (
        window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
        'micromessenger'
      ) {
        if (isMobileType.iOS()) {
          this.addressHeight =
            parseInt((310 / 812) * document.body.scrollHeight) + 'px'
        } else {
          this.addressHeight =
            parseInt((400 / 812) * document.body.scrollHeight) + 'px'
        }
      } else {
        this.addressHeight =
          parseInt((310 / 812) * document.body.scrollHeight) + 'px'
      }
    },
    handlerFinalDepartment(data, idList) {
      if (data.children.length > 0) {
        data.children.forEach((item) => {
          idList.push(item.departmentId)
          if (item.children.length > 0) {
            this.handlerFinalDepartment(item, idList)
          }
        })
      }
    },
  },
  computed: {
    selectNum() {
      return this.staffIdList.length || 0
    },
    selectdepartmentNum() {
      if (this.staffIdList.length == 0) {
        return 0
      } else {
        let warpList = []
        let arr = []
        this.staffIdList.forEach((item) => {
          if (item.departmentId.includes(',')) {
            let departmentIdList = item.departmentId.split(',')
            departmentIdList.forEach((id) => arr.push(id * 1))
          } else arr.push(item.departmentId * 1)
        })
        arr = Array.from(new Set(arr))
        this.totalInfo.forEach((item) => {
          let departmentList = []
          departmentList.push(item.departmentId)
          this.checkselectedDepartment(item.children, departmentList)
          arr.forEach((id) => {
            if (departmentList.includes(id)) warpList.push(item.departmentId)
          })
        })
        let num = Array.from(new Set(warpList)).length
        return num
      }
    },
  },
  watch: {
    selectdepartmentNum: {
      deep: true,
      handler: function () {
        if (
          this.staffIdList.length == 0 &&
          !this.displayList.department.length
        ) {
          return
        } else {
          let warpList = []
          // let arr = Array.from(new Set(this.staffIdList.map(item => item.departmentId)))
          let arr = []
          this.staffIdList.forEach((item) => {
            if (item.departmentId.includes(',')) {
              let departmentIdList = item.departmentId.split(',')
              departmentIdList.forEach((id) => arr.push(id))
            } else arr.push(item.departmentId)
          })
          arr = Array.from(new Set(arr))
          this.totalInfo.forEach((item) => {
            let departmentList = []
            departmentList.push(item.departmentId)
            this.checkselectedDepartment(item.children, departmentList)
            arr.forEach((id) => {
              if (departmentList.includes(id)) warpList.push(item.departmentId)
            })
          })
          let selectedIdList = this.staffIdList.map((item) => item.id)
          let department = []
          let includeDepartment = []
          arr.forEach((departmentId) => {
            let slectedNum = this.staffIdList.filter((item) => {
              if (item.departmentId.includes(',')) {
                let departmentIdList = item.departmentId.split(',')
                return departmentIdList.includes(departmentId)
              } else return item.departmentId == departmentId
            }).length
            let departmentInfo = this.checkTotalStaffCount(
              this.totalInfo,
              departmentId
            )
            if (
              departmentInfo.staffs &&
              slectedNum == departmentInfo.staffs.length
            ) {
              //判断是否最底层部门
              if (departmentInfo.children.length == 0) {
                let finalDepartment = this.checkSuperiorDepartment(
                  departmentInfo,
                  departmentId,
                  arr
                )
                finalDepartment &&
                  department.every(
                    (item) => item.departmentId != finalDepartment.departmentId
                  ) &&
                  department.push(finalDepartment)
              } else {
                let ifAllChildSelected = []
                departmentInfo.children.forEach((childItem) => {
                  let bl = this.checkSubordinateDepartment(
                    childItem,
                    selectedIdList
                  )
                  ifAllChildSelected.push(bl)
                })
                if (ifAllChildSelected.every((item) => item == true)) {
                  let finalDepartment = this.checkSuperiorDepartment(
                    departmentInfo,
                    departmentId,
                    arr
                  )
                  if (
                    finalDepartment &&
                    department.every(
                      (item) =>
                        item.departmentId != finalDepartment.departmentId
                    )
                  ) {
                    department.push(finalDepartment)
                    this.handlerFinalDepartment(
                      finalDepartment,
                      includeDepartment
                    )
                  }
                } else return
              }
            }
          })
          includeDepartment = Array.from(new Set(includeDepartment))
          department = department.filter((item) => {
            if (item.pid) {
              return (
                !includeDepartment.includes(item.pid) &&
                !includeDepartment.includes(item.departmentId)
              )
            } else return true
          })
          this.displayDepartmentList = [...department]
          let staffInDepartment = []
          staffInDepartment = this.fliterDepartment(
            department,
            staffInDepartment
          )
          this.displayStaffList = this.staffIdList.filter(
            (item) => !staffInDepartment.includes(item.id)
          )
        }
      },
    },
  },
  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.appointmentId = this.$route.query.appointmentId
    this.meetingRoomId = this.$route.query.meetingRoomId
    this.getUsers(this.user.companyId, this.appointmentId)
  },
  mounted() {
    this.isWeixin()
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
  },
}
</script>
<style lang="less" scoped>
.notice {
  background: #f6f6f6;
  overflow: hidden;
  height: 100%;
}
.notice-nav {
  padding-top: 12px;
}
.confereeBox-top {
  // padding: 0px 16px;
  width: 140px;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fefffe;
  .text {
    flex: 1;
    padding-left: 6px;
  }
  img {
    height: 20px;
  }
}
.confereeBox-bottom {
  padding: 12px 16px 0px;
  display: flex;
  flex-wrap: wrap;
  max-height: 135px;
  overflow: auto;
  background: #fefffe;
  margin-bottom: 12px;
}
.outsiderWrap {
  max-height: 400px;
  overflow: auto;
  .add-outsider {
    display: block;
    width: 44px;
    height: 44px;
    margin-left: 16px;
    margin-top: 12px;
  }
}
.outsider-content {
  background: #fefffe;
  padding: 12px 16px 8px;
  border-top: 1px solid #f4f4f4;
}
.outsiderBox {
  height: 32px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  color: #666666;
  .outsiderMsg {
    display: flex;
    font-size: 16px;
    align-items: center;
    background: #f4f4f4;
    border-radius: 2px;
  }
  .outsiderName {
    height: 24px;
    width: 72px;
    line-height: 24px;
    text-align: center;
    border-right: 0.5px solid rgba(0, 0, 0, 0.15);
  }
  .outsiderEMail {
    padding-left: 12px;
    width: 248px;
  }
  .outsiderDel {
    display: flex;
    align-items: center;
    padding-right: 15px;
    img {
      height: 8px;
      width: 8px;
    }
  }
}
.confrim-btn {
  width: 351px;
  position: absolute;
  bottom: 23px;
  left: 12px;
}
.searchBox {
  width: 344px;
  height: 30px;
  border-radius: 4px;
  margin-bottom: 12px;
  border: 1px solid #d9d9d9;
  font-size: 14px;
  display: flex;
  // justify-content: space-evenly;
  align-items: center;
  margin-right: 8px;
  color: #cccccc;
  background: #f1f1f1;
  img {
    width: 19px;
    height: 18px;
    margin-left: 15px;
    margin-right: 11px;
  }
}
/deep/.outsiderStyle {
  width: 296px;
  .outsider-title {
    font-size: 18px;
    line-height: 24px;
    font-weight: 400;
  }
  .van-cell::after {
    border: none;
  }
  .van-dialog__header {
    padding: 16px 0px 8px;
  }
  .van-field__label {
    margin-left: 19px;
    width: 29px;
    line-height: 36px;
    font-size: 14px;
    margin-right: 8px;
  }
  .outsider-input {
    border: 1px solid rgba(0, 0, 0, 0.15);
    height: 36px;
    padding-left: 8px;
    width: 192px;
  }
  input::-webkit-input-placeholder {
    color: #cfcfcf;
  }
  input::-moz-placeholder {
    color: #cfcfcf;
  }

  input:-moz-placeholder {
    color: #cfcfcf;
  }
  input:-ms-input-placeholder {
    color: #cfcfcf;
  }
}
.hasBorder {
  .van-field__label {
    width: 25%;
    text-align: center;
  }
  .van-cell__value {
    border: 1px #dcdcdc solid !important;
    padding: 0 8px;
    width: 60%;
  }
}
/deep/.insiderStyle {
  .van-dialog__header {
    padding: 16px 0px 8px;
  }
}
.van-dialog {
  border-radius: 4px !important;
}
.menu-box {
  display: flex;
  color: #009bff;
  font-size: 14px;
  line-height: 24px;
  align-items: center;
  white-space: nowrap;
  overflow: auto;
  height: 46px;
  border-bottom: 1px solid #ededed;
  background: #fefffe;
  padding: 0px 18px;
  .child-menu {
    display: flex;
    align-items: center;
    li {
      display: flex;
      align-items: center;
      padding-left: 8px;
      img {
        width: 16px;
        height: 17px;
        margin-right: 8px;
      }
    }
  }
}
.search-model {
  height: 100%;
  width: 100%;
  background: #f6f6f6;
  display: flex;
  flex-direction: column;
  .search-navBar {
    width: 100%;
    background: #ffffff;
    line-height: 40px;
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 18px;
    .left-icon {
      height: 100%;
      padding-top: 3px;
    }
    .search-box {
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      width: 312px;
      // height: 30px;
      .search-name {
        padding: 3px 15px;
      }
    }
  }
  .search-list {
    flex: 1;
    overflow: auto;
    // padding-bottom: 122px;
  }
}
.staffs-card {
  display: flex;
  margin-left: 9px;
  img {
    width: 46px;
    height: 47px;
    margin-right: 10px;
  }
  .staffs-card-title {
    display: flex;
    align-items: center;
  }
  .staffs-card-tag {
    padding-left: 4px;
    padding-right: 4px;
    height: 18px;
    border-radius: 4px;
    border: 1px solid #03d39d;
    font-size: 12px;
    color: #03d39d;
    line-height: 16px;
    text-align: center;
    margin-left: 12px;
  }
  .staffs-card-name {
    line-height: 24px;
  }
  .staffs-card-job {
    line-height: 24px;
    color: #999999;
  }
}
.agreeBox {
  width: 100%;
  background-color: #ffffff;
  bottom: 0px;
  left: 0;
  .select-info {
    padding-left: 16px;
    font-size: 16px;
    color: #009bff;
    margin-top: 16px;
    margin-bottom: 13px;
    line-height: 24px;
    img {
      margin-left: 20px;
      width: 18px;
      height: 11px;
    }
  }
  .agree-btn {
    border: none;
    width: 351px;
    margin: 0px auto;
  }
}
.addressList-all {
  height: 56px;
  background-color: #ffffff;
  padding-left: 16px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.addressList-card {
  // flex: 1;
  overflow: auto;
  height: 310px;
  padding-bottom: 70px;
}
.contact-card {
  display: flex;
  img {
    width: 19px;
    height: 21px;
    margin: 0px 7px;
  }
  > div {
    width: 1px;
    height: 20px;
    background: #ededed;
  }
}
</style>
